import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '~/api';
import { useToast } from '~/hooks/useToast';
import { useStoreId } from '~/providers/StoreUserProvider';

const useQueryKey = () => {
  const storeId = useStoreId();
  return ['identityGrants', storeId] as const;
};

export const useIdentityGrantList = () => {
  const storeId = useStoreId();

  return useQuery({
    queryKey: ['identityGrants', storeId],
    queryFn: () => api.store(storeId).identityGrant.list(),
  });
};

export const useIdentityGrantCreate = () => {
  const storeId = useStoreId();
  const queryKey = useQueryKey();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: api.store(storeId).identityGrant.create,
    onSuccess: () => {
      toast.show('API token created successfully');
      return queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      toast.show('Failed to create API token');
    },
  });
};

export const useIdentityGrantDelete = () => {
  const storeId = useStoreId();
  const queryKey = useQueryKey();
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation({
    mutationFn: (identityGrantId: number) =>
      api.store(storeId).identityGrant.delete(`${identityGrantId}`),
    onSuccess: () => {
      toast.show('API token deleted successfully');
      return queryClient.invalidateQueries({ queryKey });
    },
    onError: () => {
      toast.show('Failed to delete API token');
    },
  });
};
